const { APIPost } = require('utilities/APIRequestHelper');
const { getLanguage } = require('core/i18n').i18n;
// @ constants
const actionTypes = require('constants/actionTypes');
const { COMMERCIAL_ADS_CHANNEL } = require('constants/index');

const collectivesCardContentIsFetching = () => ({
    type: actionTypes.COLLECTIVE_CARD_CONTENT_REQUEST,
})

const collectivesCardContentSuccess = (response, id) => ({
    type: actionTypes.COLLECTIVE_CARD_CONTENT_SUCCESS,
    payload: {
        response,
        id
    }
});

const collectivesCardContentError = (error) => ({
    type: actionTypes.COLLECTIVE_CARD_CONTENT_ERROR,
    payload: {
        error
    }
});

const getCollectivesCardContent = (id) => (dispatch) => {
    dispatch(collectivesCardContentIsFetching());

    const params = {
        query: {
            channel: COMMERCIAL_ADS_CHANNEL,
            lang: getLanguage().toLowerCase(),
            locations: id
        }
    };

    return APIPost({
        dispatch,
        endpoint: 'requestAds',
        params
    })
        .then(response => {
            dispatch(collectivesCardContentSuccess(response.nodes, id));
        })
        .catch(response => {
            if (!!response.error) {
                dispatch(collectivesCardContentError(response.error));
            } else {
                throw response;
            }
        });
};

module.exports = {
    getCollectivesCardContent
}

